<template>
  <section>
    <!-- SB-18 -->
    <div
      id="sb-18"
      v-if="$store.state.currentLocation >= 18"
    >
      <banner-full-width headerText="Environnement et conditions climatiques"></banner-full-width>
      <content-block>
        <!-- 5-01-00 -->
        <!-- <banner-full-width headerText=""></banner-full-width> -->
        <!-- <h1 class="animated infinite bounce delay-2s">Example</h1> -->
        <h2 class="content-block__header content-block__header--red">À venir</h2>
        <p>Le temps peut changer radicalement en quelques minutes seulement lorsqu'on est sur l'eau.</p>
        <p>Cette partie vous préparera à examiner votre environnement d'aviron et à prédire le temps et les changements soudains et à y réagir. </p>
        <button-sequenced
          class="btn-nav--red"
          :loc="19"
          link="sb-19"
        >
          Dites-m’en plus
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-19 -->
    <div
      id="sb-19"
      v-if="$store.state.currentLocation >= 19"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Lire et interpréter les prévisions météorologiques</h2>
        <p>Les conditions météorologiques périlleuses surviennent rarement sans avertissement, car les conditions qui occasionnent des tempêtes, des vents forts ou des éclairs peuvent être détectées par radar météorologique, satellite et imagerie infrarouge. Les chutes de température soudaines peuvent causer l’apparition d’un brouillard épais ou signaler un changement de conditions. </p>
        <p class="pb-5">Certains clubs sont dotés de stations météo qui présentent les conditions météo en temps réel. Utilisez ces données ainsi que les données météorologiques offertes par Environnement Canada et ces divers sites ou applications météorologiques.</p>
        <div class="row">
          <div class="col-md-2 col-sm-6">
            <img
              src="@/assets/img/_content/19-myradar.png"
              class="img-fluid mx-auto d-block  mb-4"
              alt="1"
              srcset=""
            >
            <p class="text-red text-center">MyRadar</p>
          </div>
          <div class="col-md-2 col-sm-6">
            <img
              src="@/assets/img/_content/19-accuwether.png"
              class="img-fluid mx-auto d-block  mb-4"
              alt="1"
              srcset=""
            >
            <p class="text-red text-center">AccuWeather</p>
          </div>
          <div class="col-md-2 col-sm-6">
            <img
              src="@/assets/img/_content/19-predictwind.png"
              class="img-fluid mx-auto d-block  mb-4"
              alt="1"
              srcset=""
            >
            <p class="text-red text-center">PredictWind</p>
          </div>
          <div class="col-md-2 col-sm-6">
            <img
              src="@/assets/img/_content/19-sailflow.png"
              class="img-fluid mx-auto d-block  mb-4"
              alt="1"
              srcset=""
            >
            <p class="text-red text-center">SailFlow</p>
          </div>
          <div class="col-md-2 col-sm-6">
            <img
              src="@/assets/img/_content/19-windy.png"
              class="img-fluid mx-auto d-block  mb-4"
              alt="1"
              srcset=""
            >
            <p class="text-red text-center">Windy</p>
          </div>
          <div class="col-md-2 col-sm-6">
            <img
              src="@/assets/img/_content/19-weathercan.png"
              class="img-fluid mx-auto d-block  mb-4"
              alt="1"
              srcset=""
            >
            <p class="text-red text-center">MétéoCAN</p>
          </div>
        </div>
        <p class="pt-2">Il est important de bien connaître les changements de conditions météorologiques de votre région afin de pouvoir lire et interpréter l'information disponible sur ces sites ou applications.  </p>
        <p>De forts vents, de grosses vagues, de l'orage, des éclairs et du brouillard sont tous des signes que vous ne devriez pas sortir sur l'eau.  </p>
        <p>Si ces conditions surviennent alors que vous êtes sur l'eau, retournez au hangar ou dirigez-vous vers le lieu de refuge le plus près.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="20"
          link="sb-20"
        >
         Je surveillerai la météo
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-20 -->
    <div
      id="sb-20"
      v-if="$store.state.currentLocation >= 20"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Cibler les lieux de refuge avant de sortir sur l'eau</h2>
        <p>Les lieux de refuge sont des endroits où vous pouvez accoster de manière sécuritaire si le temps ou les conditions de l'eau deviennent trop dangereux pour retourner au club. Il est important de  <strong class="text-red">savoir où se trouvent les lieux de refuge avant de sortir sur l'eau</strong>.</p>
        <p>Les lieux de refuge devraient être indiqués sur les plans de circulation sur l'eau et ces plans doivent être bien visibles au club et près des quais. Vérifiez ces lieux régulièrement afin de savoir où aller en cas de danger.</p>
        <p>Si vous avez besoin de trouver un lieu de refuge, mais que vous ne savez pas où en trouver, repérez les endroits que vous pouvez approcher sans heurter de rochers, d'arbres, de murs ou d'autres installations physiques, ou les endroits où vous pouvez être debout dans l'eau pour grimper sur la berge et sortir votre embarcation de l'eau.</p>
        <p>En connaissant bien l'emplacement des lieux de refuge, vous pourrez donner des directives à votre entraîneur ou aider un équipage au besoin.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="21"
          link="sb-21"
        >
          C'est essentiel
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-21 -->
    <div
      id="sb-21"
      v-if="$store.state.currentLocation >= 21"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Suivre les protocoles sur les conditions climatiques de RCA</h2>
        <p>RCA a plusieurs documents qui traitent des protocoles de sécurité et sur les conditions climatiques.  </p>
        <ul class="chevron-list">
          <li><em>Le protocole des conditions météorologiques de RCA</em></li>
          <li><em>Dans la bonne voie{{'\xa0'}}: le protocole des conditions météorologiques de RCA</em></li>
          <li><em>Ramer en sécurité{{'\xa0'}}: Exigences et directives en matière de sécurité</em></li>
        </ul>
        <p>Vous pouvez consulter ces documents sur le site de RCA.</p>
        <button-sequenced
          class="btn-nav--red"
          :loc="22"
          link="sb-22"
        >
          Je les consulterai
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-22 -->
    <div
      id="sb-22"
      class="bg-img bg-img--03"
      v-if="$store.state.currentLocation >= 22"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Évaluer les conditions extrêmes</h2>
        <p>Il est essentiel de connaître les prévisions météorologiques lors de votre sortie sur l'eau  <strong class="text-red">et pendant les quelques heures après votre sortie</strong>. Cela vous permet de réagir rapidement si vous observez l'arrivée de conditions dangereuses.</p>
        <p><strong class="text-red">Vous êtes aussi responsable de la sécurité des personnes qui devront peut-être vous secourir </strong> si vous n'avez pas porté attention aux conditions et que vous êtes confronté à une situation d'urgence.</p>
        <p>Si vous entendez le tonnerre, retournez le plus rapidement possible au quai. Si vous avez attendu trop longtemps et que vous êtes pris par l’orage, dirigez-vous directement vers la berge et sortez de l'eau le plus vite possible. Avisez le responsable de votre club ou votre entraîneur si vous avez accosté ailleurs qu'au quai de votre club.</p>
        <p>Si le vent et les vagues sont trop forts pour que vous puissiez retourner au quai de manière sécuritaire, rendez-vous au lieu de refuge ou à l’endroit le plus près pour accoster.</p>
        <div class="row">
          <div class="col-md-2">
            <img
              src="@/assets/img/_content/22-fog.svg"
              class="img-fluid mb-4"
              alt="1"
              srcset=""
            >
          </div>
          <div class="col-md-10">
            <p><strong class="text-red">À propos du brouillard</strong></p>
            <p>L'épais brouillard pose problème dans de nombreux endroits au Canada et peut surgir de manière inattendue et rapidement.  </p>
            <p>Lorsque le brouillard s'installe, voyez si vous pouvez vous rendre au quai avant que la visibilité ne soit réduite et que vous ne soyez plus en mesure de voir la berge ou le quai où vous vous rendez. </p>
            <p>Si vous ne pouvez rien voir, dirigez-vous vers la berge la plus près pour éviter de vous perdre ou d'être heurté par d'autres bâtiments qui ne peuvent pas vous voir.</p>
          </div>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="23"
          link="sb-23"
        >
          C'est plus prudent
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-23 -->
    <div
      id="sb-23"
      v-if="$store.state.currentLocation >= 23"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Se préparer pour la pratique de l'aviron par temps froid</h2>
        <p>Si vous ramez par temps froid{{'\xa0'}}:</p>
        <ul class="chevron-list">
          <li>Portez de multiples couches pour garder votre chaleur.  </li>
          <li>Choisissez des vêtements de matériaux protecteurs qui vous permettent de rester au sec et de vous protéger de la perte de chaleur, mais permettant une amplitude de mouvement pour ramer et bouger.</li>
          <li>Prenez connaissance du protocole de votre club pour une température de l'eau de 15 °C ou moins ou en cas de mauvaises conditions météorologiques.</li>
        </ul>
        <p>Les protocoles de sortie en eau froide sont une partie importante de votre plan de gestion des risques.  <strong class="text-red">L'immersion en eau froide est extrêmement dangereuse</strong>. Elle peut entraîner une perte de chaleur bien plus rapide qu'à l'air froid. Selon l'intensité du froid de l'eau, la perte des fonctions musculaires et la confusion mentale peuvent se produire en quelques minutes à peine. </p>
        <h3 class="text-red mt-4">Immersion dans l'eau </h3>
        <div class="row">
          <div class="col-md-6">
            <p>Si vous vous retrouvez immergé dans l'eau froide, montez sur votre embarcation d'aviron de manière à ce qu'une grande partie du corps soit hors de l'eau.</p>
            <p>Adoptez la position fœtale si vous êtes seul ou la position caucus si vous êtes en groupe, pour que la partie centrale du corps soit moins exposée à l'eau froide et pour atténuer les effets d'hypothermie.</p>
          </div>
          <div class="col-md-6">
            <img
              src="@/assets/img/_content/23-help-huddle--swap.png"
              class="img-fluid mb-4"
              alt="1"
              srcset=""
            >
          </div>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="24"
          link="sb-24"
        >
          Je me préparerai pour le temps froid
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-24 -->
    <div
      id="sb-24"
      class="bg-img bg-img--04"
      v-if="$store.state.currentLocation >= 24"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Se préparer pour la pratique de l'aviron par temps chaud</h2>
        <p>Si vous ramez par temps chaud, vous devez prendre certaines précautions. Comme par temps froid, vous devez vous protéger contre les effets des températures extrêmes.</p>
        <p>Voici quelques points à prendre en considération lorsque vous ramez par temps chaud{{'\xa0'}}:</p>
        <ul class="chevron-list">
          <li>Vous et tous ceux qui rament avec vous devez porter des vêtements protecteurs appropriés pour les conditions et le type d'activité (y compris des lunettes de soleil et un chapeau).</li>
          <li>Utilisez un écran solaire à indice de protection élevé et réappliquez-en au besoin.</li>
          <li>Buvez beaucoup d'eau avant de vous exposer au temps chaud, pendant et après.</li>
          <li>Remédiez immédiatement à tout symptôme de stress thermique.</li>
        </ul>
        <button-sequenced
          class="btn-nav--red"
          :loc="25"
          link="sb-25"
        >
         Je me préparerai pour le temps chaud
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-25 -->
    <div
      id="sb-25"
      class="quiz-bg"
      v-if="$store.state.currentLocation >= 25"
    >
      <content-block>
        <h2 class="content-block__header">En cas de brouillard</h2>
        <quiz-radio
          :questions="q01"
          @quiz-complete="
                $store.dispatch('showNext', { n: 26, el: '#menu' })
              "
        ></quiz-radio>
      </content-block>
    </div>

    <footer
      class="course-menu"
      id="menu"
      v-if="$store.state.currentLocation >= 26"
    >
      <h3>Menu principal</h3>
      <cac-menu :menuItems="$store.state.menuItems"></cac-menu>
    </footer>
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';
import BannerFullWidth from '@/components/BannerFullWidth.vue';
import ContentBlock from '@/components/ContentBlock.vue';
import ButtonSequenced from '@/components/ButtonSequenced.vue';
import AccordionIcon from '@/components/AccordionIcon.vue';
import Accordion from '@/components/Accordion.vue';

// Quiz stuff
import QuizRadio from '@/components/QuizRadio.vue';
import QuizCheckbox from '@/components/QuizCheckbox.vue';

export default {
  name: 'nccp',
  components: {
    CacHeader,
    CacMenu,
    BannerFullWidth,
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    Accordion,
    QuizRadio
  },
  data() {
    return {
      showModal: false,
      // 3-01-03
      q01: [
        // Q1
        {
          id: 0,
          questionText: `
            <p class="text-key-take">Vous vous entraînez en skiff pour une prochaine course. Il vous reste un exercice à faire, mais vous remarquez que le brouillard se lève et que la température a chuté soudainement. Alors que le brouillard s'épaissit, vous estimez être à 2 km du quai.</p>
            <p class="text-key-take">Que devriez-vous faire?</p>
          `,
          questionArray: [
            'Continuer l\'exercice en ramant près de la berge et vous rendre au lieu de refuge le plus près, dont vous avez pris connaissance avant de sortir sur l\'eau.',
            'Retourner au club immédiatement. Rester près de la berge et utiliser votre sifflet.',
            'Appeler le club pour demander qu\'une embarcation de sécurité vienne vous guider.'
          ],
          corrective: 'Retourner au club immédiatement. Rester près de la berge et utiliser votre sifflet.',
          model: [],
          answer: '',
          answerText: `
            <p>Votre dernier exercice peut attendre. Vous devriez immédiatement retourner au club, en restant près de la berge. Donnez des coups de sifflet pour aviser les autres de votre présence si vous ne voyez pas à plus de 200 mètres devant vous.</p>
          `,
        },
      ],
    };
  },
  methods: {
    tabContent(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #PRIMARY COLOURS
  \*------------------------------------*/

/*------------------------------------*\
    #Mixins
  \*------------------------------------*/

/*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
.banner {
  background-image: url("../assets/img/_chapter-headers/mbl/4-environment-weather-mbl-fr.jpg");
  // background-image: url('../assets/img/_chapter-headers/mbl/01-welcome-mbl.png');
  color: #000;
  background-position: center;
  padding: 60% 10%;
  &__header {
    color: #000;
  }
}

/*------------------------------------*\
    #MEDIA SCREENS > 576px (TABLETS)
  \*------------------------------------*/
@media (min-width: 576px) {
  .banner {
    // background-image: url('../assets/img/_chapter-headers/dsk/01-welcome-dsk.png');
    background-image: url("../assets/img/_chapter-headers/dsk/4-environment-weather-dsk-fr.jpg");
    color: #000;
    padding: 10% 10% 14%;
    background-position: center;
    &__header {
      color: #000;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  // .banner {
  //   background-image: url('../assets/img/_bg/1-01-01-bg-dsk.png');
  //   color: #fff;
  //   padding: 10% 10%;
  //   background-position: center;
  //   &__header {
  //       color: #fff;
  //   }
  // }
}

/*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
